import moment from 'moment';

const truck_fields = {
  'Activo': {
    field: 'active',
    callback: active => {
      return active ? 'SI' : 'NO'
    }
  },
  'Placa': 'plate',
  'Servicio': 'service.name',
  'Proveedor': 'provider.name',
  'Modalidad': 'truck_mode.name',
  'IMEI': 'imei',
  'Expiración SOAT': {
    field: 'expiration_soat',
    callback: soat => {
      return moment(soat).isValid() ? moment(soat).format('DD/MM/YYYY') : ''
    }
  },
  'Expiración revisión técnica': {
    field: 'expiration_rev_tech',
    callback: rev_tech => {
      return moment(rev_tech).isValid() ? moment(rev_tech).format('DD/MM/YYYY') : ''
    }
  } 
}

export default truck_fields;